import request from '@/api/request'

/**
 * 获取职业矩阵信息
 */
export const getCareerMatrixImage = () => {
  return request({
    url: 'radioweb/app/jobMatrix/getList',
    method: 'get',
    params: {}
  })
}

/**
 * 获取人才服务详情
 */
export const getCareerMatrixDetail = (params) => {
  return request({
    url: 'radioweb/app/jobMatrix/getByType',
    method: 'get',
    params
  })
}
/**
 * 提交联系方式
 */
export const addMessageBoard = (data) => {
  return request({
    url: 'radioweb/app/messageBoard/addMessageBoard',
    data,
    method: 'post'
  })
}
